import type {LocationParameter} from 'src/types';

export default function locationToUrl(to: LocationParameter): string {
  const buffer = [to.pathname];
  const searchString = stringifySearch(to.search);
  const hashString = to.hash;

  if (searchString) {
    buffer.push(`?${searchString}`);
  }

  if (hashString) {
    buffer.push(`#${hashString}`);
  }

  return buffer.join('');
}

function stringifySearch(search?: Record<string, unknown>): string {
  const buffer: string[] = [];

  if (search) {
    objectToString(buffer, [], search);
  }

  return buffer.join('&');
}

function valueToString(buffer: string[], path: string[], value: unknown): void {
  if (value instanceof Array) {
    arrayToString(buffer, path, value);
  } else if (value && typeof value === 'object') {
    return objectToString(buffer, path, value as Record<string, unknown>);
  } else if (value != null) {
    stringToString(buffer, path, `${value}`);
  }
}

function objectToString(
  buffer: string[],
  path: string[],
  object: Record<string, unknown>,
): void {
  for (const name in object) {
    if (object.hasOwnProperty(name)) {
      valueToString(buffer, path.concat(name), object[name]);
    }
  }
}

function arrayToString(
  buffer: string[],
  path: string[],
  array: Array<unknown>,
): void {
  array.forEach((value, i) => {
    valueToString(buffer, path.concat(`${i}`), value);
  });
}

function stringToString(
  buffer: string[],
  path: string[],
  value: unknown,
): void {
  const rest = path.map((p) => encodeURIComponent(p));
  const base = rest.shift();

  const encodedKey = `${base}${rest.length ? `[${rest.join('][')}]` : ''}`;
  const encodedValue = encodeURIComponent(value == null ? '' : `${value}`);

  buffer.push(`${encodedKey}=${encodedValue}`);
}
